var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LinkCard',{attrs:{"icon":['fal', 'puzzle-piece'],"image":_vm.thumbnail,"title":_vm.$path('internalName', _vm.value),"badges":_vm.badges,"to":_vm.$attrs.to || { name: 'residential-template-edit', params: { id: _vm.value.id } }}})
}
var staticRenderFns = []

export { render, staticRenderFns }